// extracted by mini-css-extract-plugin
module.exports = {"main":"PatternComputeBar_main__0_9RQ","text":"PatternComputeBar_text__x6DyH","btn":"PatternComputeBar_btn__nbKLD"};